import PropTypes from "prop-types";

// Custom components
import DoubleInput from "@/Layouts/components/InputComponents/DoubleInput";

// MUI
import { Stack } from "@mui/material";

export default function MatrixColumn(props) {
	const {
		index = 0,
		item = null,
		errors = [],
		fromDisabled = false,
		toDisabled = false,
		readOnly = false,
		onActionUpdate = () => {},
	} = props;

	return (
		<Stack>
			<DoubleInput
				firstInput={{
					data: [
						{
							type: "Percent",
							min: -1000,
							max: 10000,
							dashed: fromDisabled,
							decimalsEditable: true,
							decimals: 2,
						},
					],
					value: item?.from?.value || 0,
					defaultType: item?.from?.input || "Percent",
					disabled: fromDisabled,
					error: Boolean(errors?.[index]?.from),
					readOnly: true,
					sx: { width: "82px" },
					onActionUpdate: (value) => {
						onActionUpdate?.(0, index, "column", "from", value);
					},
				}}
				secondInput={{
					readOnly,
					data: [
						{
							type: "Percent",
							min: -1000,
							max: 10000,
							dashed: toDisabled,
							decimalsEditable: true,
							decimals: 2,
						},
					],
					value: item?.to?.value || 0,
					defaultType: item?.to?.input || "Percent",
					disabled: toDisabled,
					error: Boolean(errors?.[index]?.to),
					sx: { width: "82px" },
					onActionUpdate: (value) => {
						onActionUpdate?.(0, index, "column", "to", value);
					},
				}}
			/>
		</Stack>
	);
}
MatrixColumn.propTypes = {
	index: PropTypes.number,
	item: PropTypes.object,
	errors: PropTypes.array,
	fromDisabled: PropTypes.bool,
	toDisabled: PropTypes.bool,
	readOnly: PropTypes.bool,
	onActionUpdate: PropTypes.func,
};
